import { render, staticRenderFns } from "./spcoddeliveryorder.vue?vue&type=template&id=98091442"
import script from "./spcoddeliveryorder.vue?vue&type=script&lang=js"
export * from "./spcoddeliveryorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports